export const API_PATH_apiWorkzonesAppSettingPost = '/services/workzones-management/settings';
